import { Spin } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import api from '~/services/api'

export default function RmaTimeline({ inventoryItemsId }) {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchTimeline = async () => {
      if (!inventoryItemsId) return
      setLoading(true)
      try {
        const res = await api.get(`/inventory_history_log/${inventoryItemsId}/order-rma-timeline`)
        setEvents(res.data)
      } catch (err) {
        toast.error('Failed to load RMA timeline.')
      } finally {
        setLoading(false)
      }
    }

    fetchTimeline()
  }, [inventoryItemsId])

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <Spin size="large" />
      </div>
    )
  }

  if (!events || events.length === 0) {
    return <div className="text-gray-500 text-sm py-8">No RMA events found.</div>
  }

  return (
    <div className="py-4">
      <div className="relative">
        {/* Timeline line */}
        <div className="absolute left-3 top-0 bottom-0 w-0.5 bg-gray-300" />

        {/* Events */}
        <div className="space-y-6">
          {events.map((event) => {
            const date = moment(event.created_at)
            return (
              <div key={`${event.action}-${event.created_at}`} className="relative pl-10">
                {/* Dot */}
                <div className="absolute left-0 top-1.5 w-7 h-7 bg-white border-2 border-blue-500 rounded-full flex items-center justify-center">
                  <div className="w-3 h-3 bg-blue-500 rounded-full" />
                </div>

                {/* Content */}
                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <div className="font-semibold text-gray-900">
                    {event.action} <span className="text-gray-500 text-sm font-normal">({date.format('MMM D, YYYY')})</span>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
